import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES } from '../../routing/routeConfiguration';
import { LinkTabNavHorizontal } from '../../components';

import css from './ProviderLeadsNav.module.css';

/**
 * A component that renders a navigation bar for a user-specific pages.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} props.currentPage - The current page (e.g. 'ManageListingsPage')
 * @returns {JSX.Element} User navigation component
 */
const ProviderLeadsNav = props => {
  const { className, rootClassName, currentPage } = props;
  const classes = classNames(rootClassName || css.root, className);

  const tabs = [
    {
      text: <FormattedMessage id="ProviderLeadsNav.dashboard" />,
      selected: currentPage === 'ProviderDashboardPage',
      linkProps: {
        name: 'ProviderDashboardPage',
      },
    },
    // {
    //   text: <FormattedMessage id="ProviderLeadsNav.leads" />,
    //   selected: currentPage === 'ProviderLeadsPage',
    //   linkProps: {
    //     name: 'ProviderLeadsPage',
    //   },
    // },
    // {
    //   text: <FormattedMessage id="ProviderLeadsNav.inbox" />,
    //   selected: currentPage === 'InboxPage',
    //   disabled: false,
    //   linkProps: {
    //     name: 'InboxPage',
    //     params: { tab: 'sales' },
    //   },
    // },
    {
      text: <FormattedMessage id="ProviderLeadsNav.listings" />,
      selected: currentPage === 'ManageListingsPage',
      disabled: false,
      linkProps: {
        name: 'ManageListingsPage',
      },
    },
    // {
    //   text: <FormattedMessage id="ProviderLeadsNav.availability" />,
    //   selected: currentPage === 'ProviderAvailabilityCalendarPage',
    //   disabled: false,
    //   linkProps: {
    //     name: 'ProviderAvailabilityCalendarPage',
    //   },
    // },
  ];

  return (
    <LinkTabNavHorizontal className={classes} tabRootClassName={css.tab} tabs={tabs} skin="dark" />
  );
};

export default ProviderLeadsNav;
